module.exports = __webpack_public_path__ + "static/media/natours.f51c1e20.jpg";